module.exports = __webpack_public_path__ + "static/media/tutorial-01.3634c6dd.gif";